export default `
mutation ApproveTimeOff($shiftId: ID!, $approvedBy: ID!) {
  approveTimeOff(shiftId: $shiftId, approvedBy: $approvedBy) {
    createdAt
    updatedAt
    publishedAt
    acknowledgedAt
    updatedBy
    shiftId
    status
    createdBy
    userId
    isDeleted
    propertyId
    note
    startTime
    endTime
    serviceProviderId
    requests
    divisionId
    requiredLevels
    timezone
  }
}
`;